import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './DutyTypeEditor.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import { MainCatalogTypes, MainCatalogs_Classes, OMDutyType_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class DutyTypeEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    dt_Input_Classname: MdsLax<InstanceType<typeof SearchSelect>>;

    dt_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    dt_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    dt_Input_TextColor: HTMLInputElement;
    dt_Input_BackgroundColor: HTMLInputElement;
    dt_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    dt_Checkbox_Active: MdsLax<InstanceType<typeof CheckBox>>;
    dt_Checkbox_Cancelled: MdsLax<InstanceType<typeof CheckBox>>;
    dt_Checkbox_Present: MdsLax<InstanceType<typeof CheckBox>>;

    dt_Input_PercentageCount: MdsLax<InstanceType<typeof NumberInput>>;
    dt_Input_PercentageFree: MdsLax<InstanceType<typeof NumberInput>>;
    dt_Input_PercentagePresent: MdsLax<InstanceType<typeof NumberInput>>;

    formData: MainCatalogTypes.OMDutyType_SaveData = {
        ID: "",
        is_new_status: null,
        Classname: "",
        code: "",
        description: "",
        is_active: null,
        is_cancelled: null,
        is_present: null,
        percentage_count: null,
        percentage_free: null,
        percentage_present: null,
        order: null,
        coloration: null
    };

    prepareFormData(data?: MainCatalogTypes.OMDutyType_LoadData): void {

        let className = null;

        if (data) {

            this.dt_Input_Code.setValue(data.code, true);
            this.dt_Input_Description.setValue(data.description_D, true);
            this.dt_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.dt_Input_BackgroundColor.value = data.coloration.BackColor.Hex;
            this.dt_Input_Order.setValue(data.order, true);

            this.dt_Checkbox_Active.setValue(data.is_active, true);
            this.dt_Checkbox_Cancelled.setValue(data.is_cancelled, true);
            this.dt_Checkbox_Present.setValue(data.is_present, true);

            this.dt_Input_PercentageCount.setValue(data.percentage_count, true);

            switch (data.Classname) {
                case OMDutyType_Classes.PresentType:

                    this.dt_Input_PercentageFree.setValue(null, true);
                    this.dt_Input_PercentagePresent.setValue(data.percentage_present, true);

                    this.dt_Input_PercentageFree.setReadonly(true);
                    this.dt_Input_PercentagePresent.setReadonly(false);

                    this.UiModder.domClass.add(this.dt_Input_PercentageFree.domNode, "w3-disabled");
                    this.UiModder.domClass.remove(this.dt_Input_PercentagePresent.domNode, "w3-disabled");
                    break;
                case OMDutyType_Classes.AbsentType:

                    this.dt_Input_PercentageFree.setValue(data.percentage_free, true);
                    this.dt_Input_PercentagePresent.setValue(null, true);

                    this.dt_Input_PercentagePresent.setReadonly(true);
                    this.dt_Input_PercentageFree.setReadonly(false);

                    this.UiModder.domClass.add(this.dt_Input_PercentagePresent.domNode, "w3-disabled");
                    this.UiModder.domClass.remove(this.dt_Input_PercentageFree.domNode, "w3-disabled");
                    break;
            }

            this.dt_Input_Classname.loadListValues(data.Classname, true);
            //this.UiModder.domClass.add(this.dt_Input_Classname.scrollContainer, "w3-2018-coconut-milk");
            this.dt_Input_Classname.setReadonly(true);
            className = data.Classname;

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.dt_Input_Code.setValue("", true);
            this.dt_Input_Description.setValue("", true);
            this.dt_Input_BackgroundColor.value = "#ffffff";
            this.dt_Input_TextColor.value = "#000000";
            this.dt_Input_Order.setValue(null, true);

            this.dt_Checkbox_Active.setValue(true, true);
            this.dt_Checkbox_Cancelled.setValue(false, true);
            this.dt_Checkbox_Present.setValue(false, true);

            this.dt_Input_PercentageCount.setValue(null, true);
            this.dt_Input_PercentageFree.setValue(null, true);
            this.dt_Input_PercentagePresent.setValue(null, true);

            this.dt_Input_Classname.loadListValues();
            //this.UiModder.domClass.add(this.dt_Input_Classname.scrollContainer, "w3-2018-coconut-milk");
            this.dt_Input_Classname.setReadonly(false);

            this.UiModder.domClass.add(this.dt_Input_PercentagePresent.domNode, "w3-disabled");
            this.UiModder.domClass.add(this.dt_Input_PercentageFree.domNode, "w3-disabled");

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData(className);
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(className?: string): void {

        this.formData.code = this.dt_Input_Code.getValue();
        this.formData.description = this.dt_Input_Description.getValue();

        this.formData.is_active = this.dt_Checkbox_Active.getValue();
        this.formData.is_cancelled = this.dt_Checkbox_Cancelled.getValue();
        this.formData.is_present = this.dt_Checkbox_Present.getValue();

        this.formData.percentage_count = this.dt_Input_PercentageCount.getValue();
        this.formData.percentage_free = this.dt_Input_PercentageFree.getValue();
        this.formData.percentage_present = this.dt_Input_PercentagePresent.getValue();

        className ? this.formData.Classname = className : this.formData.Classname = this.dt_Input_Classname.getValue();


        this.formData.order = this.dt_Input_Order.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.dt_Input_TextColor.value;
        let backHex = this.dt_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        if (!this.formData.description) b = false;

        if (!this.formData.Classname) {

            this.indicateErrorOnInput(this.dt_Input_Classname);
            this.dt_Input_Classname.setMandatory(true);
            b = false;
        }

        this.__delayDisableSaveButton(!b);

        return b;
    }

    _onChangeDutyTypeClassInputData() {

        let className = this.dt_Input_Classname.getValue();

        switch (className) {
            case OMDutyType_Classes.PresentType:

                this.dt_Input_PercentageFree.setValue(null);

                this.dt_Checkbox_Present.setValue(true);

                this.UiModder.domClass.add(this.dt_Input_PercentageFree.domNode, "w3-disabled");
                this.UiModder.domClass.remove(this.dt_Input_PercentagePresent.domNode, "w3-disabled");
                break;
            case OMDutyType_Classes.AbsentType:

                this.dt_Input_PercentagePresent.setValue(null);

                this.dt_Checkbox_Present.setValue(false);

                this.UiModder.domClass.add(this.dt_Input_PercentagePresent.domNode, "w3-disabled");
                this.UiModder.domClass.remove(this.dt_Input_PercentageFree.domNode, "w3-disabled");
                break;
        }

        this.serializeFormData();
        this.checkDirty();
    }
    

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.OMDutyType;

        this.dt_Input_Classname.setOuterPlaceholder("MainCatalogsEditor_Placeholder_DutyTypeClass");

        this.dt_Input_Code.setMaxLength(10);
        this.dt_Input_Description.setMaxLength(255);
        this.dt_Input_PercentageCount.setNumberType("percent");
        this.dt_Input_PercentageCount.setUnit("%");
        this.dt_Input_PercentageFree.setNumberType("percent");
        this.dt_Input_PercentageFree.setUnit("%");
        this.dt_Input_PercentagePresent.setNumberType("percent");
        this.dt_Input_PercentagePresent.setUnit("%");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(DutyTypeEditor.prototype, {
  dt_Input_Classname: () => (new SearchSelect()),
  dt_Input_Code: () => (new Edit()),
  dt_Input_Description: () => (new Edit()),
  dt_Input_Order: () => (new NumberInput()),
  dt_Checkbox_Active: () => (new CheckBox()),
  dt_Checkbox_Cancelled: () => (new CheckBox()),
  dt_Checkbox_Present: () => (new CheckBox()),
  dt_Input_PercentageCount: () => (new NumberInput()),
  dt_Input_PercentageFree: () => (new NumberInput()),
  dt_Input_PercentagePresent: () => (new NumberInput()),
});
export default mdsWidget(DutyTypeEditor);
